/** Build identity is explicit; the browser bundle also serves the desktop shell. */
export type AppTarget = 'shared' | 'mobile'

export function capabilities(target: AppTarget, native: boolean) {
  const isMobileApp = target === 'mobile' && native
  const isDesktopApp = target === 'shared' && native
  return { isMobileApp, isDesktopApp, canHost: isDesktopApp, canSelfUpdate: isDesktopApp }
}

export const isMobileBuild = import.meta.env.VITE_APP_TARGET === 'mobile'
export const { isDesktopApp, isMobileApp, canHost, canSelfUpdate } = capabilities(
  isMobileBuild ? 'mobile' : 'shared',
  typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window,
)
